<template>
	<div>
  <div class="grid">
    <div class="col-12">

          <ResumedCharts />

        </div>

  </div> 

  <TabView ref="tabview1">
    <TabPanel header="EN CALIDAD">
      <div class="grid"> <OtiSquareAdmin v-for="order in orders.filter((order) => order.status == 3 || order.status == '3')" :key="order.id" :userGroup="opGroup" :order="order" /> </div>
    </TabPanel>
    <TabPanel header="INCIDENCIAS">
      <div class="grid"> <OtiSquareAdmin v-for="order in orders.filter((order) => order.incidencia_pendiente && order.incidencia_pendiente.length)" :key="order.id" :userGroup="opGroup" :order="order" /> </div>
    </TabPanel>
  </TabView>

</div>

</template>

<script>
import CrudService from "./../../services/crud.service.js" 
import OtiSquareAdmin from "./OtiSquareAdmin.vue";
import ResumedCharts from "./ResumedCharts.vue";

export default {
  props: ['opGroup'],
  data() {
    return {
      orders: [],
    }
  },
  components: {
    OtiSquareAdmin,
    ResumedCharts
  },
	computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentGroup() {
      return this.$store.state.auth;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    }

    this.getOrders();
  }, 
  methods: {
    countStatus(status) {
      return this.orders.filter((order) => order.status === status).length;
    },
    getOrders() {
      CrudService.getCRUD("orden", "orden").then((data) => (this.orders = data));
    },

  }

}
</script>

<style scoped>
</style>